export const honestFAQ = [
  {
    question: "Can I get a mortgage as a non-resident?",
    answer:
      "No. Japanese banks do not lend to foreign non-residents without a local guarantor and documented Japan-sourced income. If you are not living and working in Japan, plan on cash only. We have never seen an overseas buyer secure a mortgage. Do not build your strategy around it.",
  },
  {
    question: "Does buying property give me a visa?",
    answer:
      "No. There is no \"golden visa\" or investor residency attached to real estate ownership in Japan. Owning a house does not entitle you to live here. You will still need a standard visa for stays longer than 90 days. We mention this because some buyers assume otherwise — and we would rather tell you now than after purchase.",
  },
  {
    question: "How many days can I rent on Airbnb?",
    answer:
      "Under the Minpaku Law, unlicensed short-term rental is capped at 180 nights per year. For unlimited rental income, you need a ryokan-gyo licence, which requires specific zoning, fire-code compliance, and a local manager on call 24 hours. We file the paperwork. We do not pretend the cap does not exist.",
  },
  {
    question: "Why is that house only ¥500,000?",
    answer:
      "Because it is abandoned, often structurally compromised, in a shrinking town with thin rental demand, and needs a full gut renovation that may cost 3–5× the purchase price. Sometimes the right answer is \"do not buy this one.\" We model occupancy, renovation cost, and realistic rental income before you commit. No cherry-picked examples.",
  },
];